import Buyers from 'modules/buyer/list';
import Header from 'modules/header/farm/home';
import {useCookies} from 'react-cookie';
import {useEffect} from 'react';
const BuyersPage = () => {
  const [, , removeCookie] = useCookies(['cultivationGuid']);
  useEffect(() => {
    removeCookie('cultivationGuid', {
      path: '/',
      domain: 'mazraeapp.com',
    });
  }, []);
  return (
    <>
      <Header />
      <Buyers app="farm" />
    </>
  );
};

export default BuyersPage;
